export default "__VITE_ASSET__fSqUPseo__"